const exservice = 'storybank';

export function tryToGetToken() {
    window.location.href = `${process.env.REACT_APP_ACCOUNT_BASE_URL}/accountapi/auth/try_to_get_token?exservice=${exservice}&return_to=${encodeURIComponent(window.location.href)}`;
}
